module.exports = function() {
  return new Worker(__webpack_public_path__ + "a6686008b12291ecc5b1.worker.js");
};